<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import MaterialForm from "@/views/admin/components/MaterialForm.vue";
export default {
    name: "Materiais",
    components: {
        Button,
        Loader,
        MaterialForm
    },
    data() {
        return {
            loader: false,
            show: false,
            list: [],
            filter: {status:"",descricao:"",unidade:"",sku:"",nome:""}
        };
    },
    methods: {
        ...mapActions("admin", ["MATERIAL_LIST"]),
        async load() {
            this.loader = true
            await this.MATERIAL_LIST({...this.filter}).then(({ data }) => { if (data) this.list = data })
            this.loader = false
        }
    }
};
</script>

<template lang="pug">
.Materiais
    .head.row.ac.col-s
        h1(style="margin-right: 12px") Materiais
        Button(:layout="show ? 'red-go' : 'green-go'" @click="show = !show" title="NOVO MATERIAL") {{ show ? "x" : "+" }}
        .new(v-if="show") 
            MaterialForm(:reload="load")
    .filter.row.ae.col-s
        .col.g1.g6-s
            label Status
            select(v-model="filter.status")
                option(value="") Selecione
                option(value="ativo") Ativo
                option(value="inativo") Inativo
        .col.g1.g6-s
            label Unidade
            select(v-model="filter.unidade")
                option(value="") Selecione
                option(value="unitario") Unitário
                option(value="metro") Metro
        .col.g1.g6-s
            label SKU
            input(v-model="filter.sku" placeholder="SKU")
        .col.g2.g6-s
            label Nome
            input(v-model="filter.nome" placeholder="Nome")
        .col.g5.g12-s
            label Descrição
            input(v-model="filter.descricao" placeholder="Descrição")
        Button(layout="green-go" @click="load") 
            i.fa.fa-search
            | Pesquisar
    .row.ac.jc.g12(v-if="loader" style="margin-top: 30px")
        Loader
    .list(v-else)
        .head.row.g12
            .g3 Nome
            .g3 SKU
            .g3 Unidade
            .g3 Status
        .line(v-for="c,i in list")
            .item.row.ac(@click="list[i].s=!c.s;list=[...list]")
                .g3 {{c.nome}}
                .g3 {{c.sku}}
                .g3 {{c.unidade}}
                .g3 {{c.status}}
            .form(v-if="c.s")
                MaterialForm(:f="c" :reload="load")
</template>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.Materiais
    @include page
    label
        @include label
        margin-bottom: 3px
    .filter
        border: none
        background: none
        padding: 10px 16px
        .col
            margin-right: 12px
    .new
        flex: 1
    .line
        &:nth-child(even)
            background: #ddd
        .item
            font-size: 14px
            border-radius: 6px
            padding: 12px
            cursor: pointer            
            &:hover
                background: rgba($purple,.7)
                color: white
        .form
            padding: 20px
            background: #eee
            margin-bottom: 30px
            border-radius: 20px
            @include border

</style>